import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "./containers/MainContainer";
import TopBar from "./containers/TopBar";
import t from "../Locale";
import { Else, If, Then } from "react-if";

export default function RetailerAccountTemplate({
	title = "",
	children = <></>,
}) {
	const credits = useSelector((state) => state.login.user?.credits);
	const token = useSelector((state) => state.login.token);

	return (
		<MainContainer
			render={
				<TopBar
					leftSide="-1"
					title={t(title)}
					style={{
						height: 80,
						alignContent: "flex-end",
						paddingBottom: 20,
					}}
				/>
			}
		>
			<If condition={!token}>
				<Then>
					<h3 style={{ textAlign: "center", marginTop: 100 }}>
						Please Login First
					</h3>
				</Then>
				<Else>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							flexDirection: "column",
						}}
					>
						<h1>Credit Balance: SGD {credits}</h1>
						{children}
					</div>
				</Else>
			</If>
		</MainContainer>
	);
}
